module.exports = __webpack_public_path__ + "img/add_btn_icon481.ff6cc56d.svg";